export const REPLACEMENTS_REDUCER_NAME = 'replacements'
export const REPLACEMENTS_MODAL = 'replacements'
